/* eslint-disable no-undef */

const APP_VERSION = '2.2.6';

export const logException = async (
  customerId,
  exception,
  eventName,
  urlName,
  eventType
) => {
  const payload = {
    customerId: customerId || 'not captured',
    logEventType: eventType,
    source: 'webapp',
    appVersion: APP_VERSION,
    deviceModel: navigator.platform,
    browser: navigator.userAgent,
    browserVersion: navigator.appVersion,
    screenName: urlName,
    eventName,
    errorMessage: exception,
  };
  // FIXME: This is for developers only
  //   const res = await errorApi(
  //     'https://api.socialworth.in/esintapiprod/exception-log',
  //     payload,
  //     'POST'
  //   );
};
